'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var StoresQuadRuStore = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "#2B71F6",
                fillRule: "evenodd",
                d: "M34.119 4H21.87C16.118 4 14 6.11 14 11.876v12.248C14 29.89 16.11 32 21.876 32h12.248c5.766 0 7.88-2.11 7.88-7.876V11.876C41.993 6.11 39.884 4 34.118 4",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "M29.96 21.31a1.73 1.73 0 0 1-1.331-1.673v-9.315c0-.898.861-1.557 1.75-1.338l5.627 1.384c.782.193 1.33.882 1.33 1.673v9.316c0 .898-.86 1.556-1.75 1.338zM19.383 25.597a1.73 1.73 0 0 1-1.33-1.673V14.61c0-.899.86-1.557 1.75-1.338l5.627 1.384c.782.193 1.33.882 1.33 1.673v9.315c0 .898-.861 1.557-1.75 1.338z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "M24.657 23.453a1.73 1.73 0 0 1-1.33-1.672v-9.316c0-.898.86-1.556 1.75-1.338l5.626 1.385c.783.192 1.331.882 1.331 1.673V23.5c0 .898-.861 1.557-1.75 1.338z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#2B71F6",
                d: "M28.355 24.364a.57.57 0 0 1-.43-.533l-.245-7.108c-.07-.942-.781-1.691-1.523-1.911a.1.1 0 0 0-.109.04.084.084 0 0 0 .02.112c.183.14.686.596.686 1.381l-.001 7.62zM33.657 22.218a.566.566 0 0 1-.43-.53l-.245-7.108c-.07-.943-.781-1.692-1.523-1.912a.1.1 0 0 0-.109.04.083.083 0 0 0 .02.113c.183.14.686.595.686 1.38l-.001 7.622z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                fillRule: "evenodd",
                d: "M21.773 46.43q.804.552 1.887.551.748 0 1.35-.264.615-.276.96-.77.359-.496.358-1.157 0-.683-.335-1.133a2.26 2.26 0 0 0-.826-.694 8 8 0 0 0-1.206-.495 12 12 0 0 1-.915-.353 1.8 1.8 0 0 1-.57-.407.9.9 0 0 1-.223-.616q0-.484.39-.76.392-.285.994-.286.559 0 .972.275.412.264.636.77l1.083-.176q-.301-.891-1.016-1.398Q24.597 39 23.604 39a3.1 3.1 0 0 0-1.295.264q-.58.264-.916.76-.323.484-.323 1.134 0 .693.323 1.145.335.44.815.682t1.229.484q.558.188.904.342.345.153.57.407a.9.9 0 0 1 .234.627.94.94 0 0 1-.413.804q-.414.285-1.072.286-.648 0-1.094-.286-.447-.297-.77-.914l-1.106.176a2.8 2.8 0 0 0 1.083 1.52m-8 .441H12.42l-2.143-2.95H9.15v2.95H8v-7.76h2.769q.804 0 1.44.307.636.309.982.859a2.2 2.2 0 0 1 .358 1.244q0 .88-.547 1.508-.548.617-1.463.815zM9.15 40.156v2.73h1.619q.715 0 1.15-.374.446-.385.446-.991 0-.605-.446-.98-.435-.385-1.15-.385zm7.673 6.825q-.613 0-1.105-.297a2.16 2.16 0 0 1-.77-.837 2.6 2.6 0 0 1-.28-1.21V41.18h1.095v3.368q0 .65.368 1.057t.95.407q.602 0 1.004-.418t.402-1.046V41.18h1.094v5.691H18.8l-.256-.859a1.96 1.96 0 0 1-.737.716 1.96 1.96 0 0 1-.983.253m14.127-1.057-.1.947h-1.017q-.904 0-1.373-.44-.469-.441-.469-1.266v-3.027h-.993v-.958h.993l.302-1.651h.792v1.65h1.765v.959h-1.765v3.027q0 .76.749.76zm2.075.683q.691.375 1.574.374.882 0 1.574-.374a2.73 2.73 0 0 0 1.083-1.046q.39-.672.39-1.53 0-.86-.39-1.53a2.73 2.73 0 0 0-1.084-1.046q-.69-.385-1.573-.385-.882 0-1.574.385-.693.374-1.084 1.046-.39.67-.39 1.53 0 .858.39 1.53.391.671 1.084 1.046m2.947-1.156q-.525.54-1.373.54-.85 0-1.373-.54-.526-.55-.526-1.42 0-.88.526-1.42.525-.55 1.373-.55t1.373.55q.536.54.536 1.42t-.536 1.42m2.848 1.42V41.18h.792l.235.814q.257-.429.636-.616.38-.198.905-.198h.268l.089 1.035h-.625q-.604 0-.904.34-.302.343-.302.925v3.391zm9.17-2.543q.01-.12.01-.341a2.93 2.93 0 0 0-.38-1.486 2.67 2.67 0 0 0-1.06-1.046 3 3 0 0 0-1.518-.385q-.861 0-1.53.385-.67.374-1.05 1.046-.38.67-.38 1.53 0 .847.38 1.519t1.061 1.057q.682.375 1.54.374.904 0 1.642-.418a2.45 2.45 0 0 0 1.083-1.19l-1.027-.164a1.6 1.6 0 0 1-.659.572 2.2 2.2 0 0 1-.971.21q-.793 0-1.306-.452-.514-.451-.604-1.21zm-4.087-1.915q.48-.386 1.139-.386.67 0 1.138.397.48.386.626 1.023h-3.529q.156-.65.626-1.034",
                clipRule: "evenodd"
            })
        ]
    }));
});
StoresQuadRuStore.displayName = "StoresQuadRuStore";

export { StoresQuadRuStore, StoresQuadRuStore as default };
